export function getApplicationContext(): 'ios' | 'web' {
  const hasIosUserAgent = window.navigator.userAgent.includes(
    'Idealist Mobile App iOS'
  );

  return hasIosUserAgent ? 'ios' : 'web';
}
